import { useEffect, useState } from "react";

import { ArrowButton, Button, DatePicker, Modal, TextField, Typography } from "@king-ict/eupisi-ui/components";
import { useValidation } from "@king-ict/eupisi-ui/hooks";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { createFormOfTeaching, editFormOfTeaching, getFormOfTeachingById } from "../../api/nisooApi";
import { useInput } from "../../hooks";
import { FormOfTeaching, FormOfTeachingValidationScheme } from "../../models/FormOfTeaching";
import { codebookRouteFormOfTeaching } from "../../routes/routes";
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookKnowledgeCheckEdit(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { handleChange } = useInput();


  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formOfTeaching, setFormOfTeaching] = useState<FormOfTeaching>({ name: "", canDelete: true });

  useEffect(() => {
    if (!location || !location.state || !(location.state as any).formOfTeachingId) {
      setLoading(false);
      return;
    }
    const getFormOfTeaching = async () => {
      var result = await getFormOfTeachingById((location.state as any).formOfTeachingId);
      setFormOfTeaching(result);
      setLoading(false);
    }
    getFormOfTeaching();
  }, [location]);


  const [errors, doValidations] = useValidation({
    data: formOfTeaching,
    validationSchema: FormOfTeachingValidationScheme,
  });

  const saveChanges = () => {
    var isValid = doValidations();
    if (isValid) {
      setOpenConfirmModal(true);
    }
  }

  const handleCancelConfirmModal = async () => {
    setOpenConfirmModal(false);
  }

  const handleConfirmedConfirmModal = async () => {
    setOpenConfirmModal(false);
    if (formOfTeaching.dateTo) {
      formOfTeaching.dateTo = new Date(Date.UTC(formOfTeaching.dateTo.getFullYear(), formOfTeaching.dateTo.getMonth(), formOfTeaching.dateTo.getDate()));
    }

    if (formOfTeaching.id) {
      await editFormOfTeaching(formOfTeaching.id, formOfTeaching);
    }
    else {
      await createFormOfTeaching(formOfTeaching);
    }
    navigateToList();
  }

  const cancel = () => {
    navigateToList();
  }

  const navigateToList = () => {
    history.push(
      codebookRouteFormOfTeaching(),
      {
        page: "list"
      }
    );
  }

  return (
    <>
      <Row>
        <Col md={9}>
          <ArrowButton backwards ariaLabel="" onClick={navigateToList} />
          <span className={styles.backButtonCaption}>
            {t("codeBook.returnToList")}
          </span>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={8}>
          <h3>{t("codeBook.formOfTeaching")}</h3>
        </Col>
        <Col md={4} className="d-flex justify-content-end align-items-center">
          <Button outline onClick={() => cancel()}>
            {t("common.cancel")}
          </Button>
          <Button className="ml-3" onClick={() => saveChanges()}>
            {t("common.save")}
          </Button>
        </Col>
      </Row>
      {!loading &&
        <Row className="mt-5">
          <Col md={8}>
            <TextField
              name={nameof<typeof formOfTeaching>("name")}
              label={t("common.name")}
              errorText={errors?.name}
              value={formOfTeaching.name}
              maxLength={80}
              onChange={handleChange(setFormOfTeaching)}
            />
          </Col>
          <Col md={4} >
            <DatePicker
              value={formOfTeaching.dateTo}
              label={t("common.dateTo")}
              name={nameof<typeof formOfTeaching>("dateTo")}
              onChange={handleChange(setFormOfTeaching)}
              isClearable={true}
              minYear={new Date().getFullYear() - 25}
              maxYear={new Date().getFullYear() + 25}
            />
          </Col>
        </Row>
      }
      <Modal
        type="confirm"
        open={openConfirmModal}
        cancelText={t("common.cancel")}
        confirmText={t("common.saveChanges")}
        onClose={handleCancelConfirmModal}
        onConfirm={handleConfirmedConfirmModal}
      >
        <div>
          <Typography component="h1" variant="largeBold">
            {t("common.areYouSureSaveChanges")}
          </Typography>
        </div>
      </Modal>
    </>
  );
}